import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/CookieConsent.css';

const COOKIE_KEY = 'einvitation_cookie_consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      // Slight delay so it doesn't flash on first load
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookie consent">
      <div className="cookie-banner-content">
        <div className="cookie-icon">🍪</div>
        <div className="cookie-text">
          <p>
            We use cookies and similar technologies to improve your experience on our site.
            By continuing, you agree to our{' '}
            <Link to="/privacy">Privacy Notice</Link> in compliance with the{' '}
            <strong>Data Privacy Act of 2012 (RA 10173)</strong>.
          </p>
        </div>
        <div className="cookie-actions">
          <button className="cookie-btn accept" onClick={handleAccept}>
            Accept
          </button>
          <button className="cookie-btn decline" onClick={handleDecline}>
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
